import getUrlParam, { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

let checkSearchTitleValue = (val, title) => {
  if (val) {
    let substrings = val
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((item) => escapeRegExp(item));
    if (!substrings.length) {
      return false;
    }
    let str = title.toLowerCase();
    return new RegExp(`\\b(${substrings.join('|')})\\b`, 'i').test(str);
  } else {
    return false;
  }
};

const searchIncludesTitleConditional = (title) => {
  const searchParam = getUrlParam('search');
  if (!searchParam) {
    return false;
  }
  let searchValue;
  try {
    searchValue = decodeUrlQueryValue(searchParam).split('#')[0];
  } catch (e) {
    // If decodeUrlQueryValue fails (e.g., malformed URI), use the value as-is
    searchValue = searchParam.split('#')[0];
  }
  let value = checkSearchTitleValue(searchValue, title);
  return value;
};

const relevantActivityFalseCondition = () =>
  getUrlParam('relevant-activity') && getUrlParam('relevant-activity') === 'false';

export { searchIncludesTitleConditional, checkSearchTitleValue, relevantActivityFalseCondition };
